import { AGE_CHANGE, AgeCategoryAction } from './types';
import { GetAppState } from '../index';
import { AgeCategory } from '../../../models/AgeCategory';

export const changeAge = (ageCategory: AgeCategory): AgeCategoryAction => {
    return {
        type: AGE_CHANGE,
        payload: ageCategory
    };
};

export function getAgeCategoryParam(getState: GetAppState): string | undefined {
    const ageCategory = getState().ageCategory || '';
    return ageCategory !== AgeCategory.ALL_AGES ? ageCategory : undefined;
}
